import React, { useState } from 'react';
import {
  arrayOf, number, shape, string,
} from 'prop-types';
import {
  Checkbox, Select, Space, Typography,
} from 'antd';
import CWOConfigProvider from 'helpers/cwoConfigProvider';

/**
 * Filtering controls for the agro-operation map creation form.
 * Renders a "disable filtering" checkbox and a median-strength dropdown
 * (disabled while the checkbox is checked), writing both values into hidden
 * form fields so Rails strong-params pick them up on submit.
 */
const FilteringControls = ({
  disableName,
  strengthName,
  disableLabel,
  strengthLabel,
  options,
  defaultStrength = 2,
}) => {
  const [disabled, setDisabled] = useState(false);
  const [strength, setStrength] = useState(defaultStrength);

  return (
    <CWOConfigProvider>
      <Space direction="vertical" size="small">
        <Checkbox
          className="js-disable-filtering"
          checked={disabled}
          onChange={(event) => setDisabled(event.target.checked)}
        >
          {disableLabel}
        </Checkbox>
        <input type="hidden" name={disableName} value={disabled} />

        <Space>
          <Typography.Text>{strengthLabel}</Typography.Text>
          <Select
            className="js-filter-strength"
            value={strength}
            disabled={disabled}
            onChange={setStrength}
            options={options}
            style={{ minWidth: 200 }}
          />
        </Space>
        <input type="hidden" name={strengthName} value={strength} />
      </Space>
    </CWOConfigProvider>
  );
};

FilteringControls.propTypes = {
  disableName: string.isRequired,
  strengthName: string.isRequired,
  disableLabel: string.isRequired,
  strengthLabel: string.isRequired,
  options: arrayOf(shape({ value: number, label: string })).isRequired,
  defaultStrength: number,
};

export default FilteringControls;
